import getRGPDService from "@/services/RGPDService";
import Consents from "@/models/Consents";
import { UPDATE_CONSENTS } from "./mutation-types";

const getConsents = async ({ commit, rootState }, qrcodeId: string) => {
    try {
        const consents: Consents = await getRGPDService().getConsents(qrcodeId);
        if (consents) {
            commit(UPDATE_CONSENTS, {
                authState: rootState.auth,
                consents
            });
        }
    } catch {
        console.log("error while getting consents");
    }
};

const updateConsents = async (
    { commit, dispatch, rootState },
    data: {
        qrcodeId: string;
        termsAndConditionsConsent: boolean;
        shareEmailConsent?: boolean;
    }
) => {
    await getRGPDService().addConsents(
        data.qrcodeId,
        data.termsAndConditionsConsent,
        data.shareEmailConsent
    );

    if (rootState.auth.authenticated) {
        dispatch("getConsents", data.qrcodeId);
    } else {
        commit(UPDATE_CONSENTS, {
            authState: rootState.auth,
            consents: {
                termsAndConditionsConsent: data.termsAndConditionsConsent,
                shareEmailConsent: data.shareEmailConsent
            }
        });
    }
};

export default {
    getConsents,
    updateConsents
};
